/**
 * 지도 화면 전용 GraphQL 쿼리.
 */
import { gql } from "@apollo/client";
import { STORE_INFO_FRAGMENT } from "../../../api/fragments";

export const JUST_STORES = gql(`
  query JustStores($lat: Float, $lng: Float, $radiusKm: Float) {
    justStores(lat: $lat, lng: $lng, radiusKm: $radiusKm) {
      id
      lat
      lng
      title
      isProductAllSoldOut
      closingHours
      reserveTime
      todaysProducts {
        id
      }
      pack {
        id
        currentCount
        isTodayEnabled
        isTomorrowEnabled
        isOverTodayPickupTime
      }
    }
  }
`);

export const GET_STORE_DETAIL = gql`
  query StoreDetail($storeId: Int!) {
    store(id: $storeId) {
      ...StoreInfo
      address
      distance
    }
  }
  ${STORE_INFO_FRAGMENT}
`;
